import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useGettoncini } from '../contexts/GettonciniContext';
import { GettonciniIcon } from '../icons';
import styles from '../styles/UserSettings.module.css';

const formatExpirationCountdown = (expiresAtIso, nowMs) => {
  const expiresAtMs = new Date(expiresAtIso).getTime();
  if (!Number.isFinite(expiresAtMs)) {
    return null;
  }

  const diffMs = expiresAtMs - nowMs;
  if (diffMs <= 0) {
    return 'scaduti';
  }

  const diffMinutes = Math.floor(diffMs / 60000);
  if (diffMinutes < 1) {
    return 'tra meno di 1 minuto';
  }
  if (diffMinutes < 60) {
    return diffMinutes === 1 ? 'tra 1 minuto' : `tra ${diffMinutes} minuti`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  const remainingMinutes = diffMinutes % 60;
  if (remainingMinutes === 0) {
    return diffHours === 1 ? 'tra 1 ora' : `tra ${diffHours} ore`;
  }

  const hoursLabel = diffHours === 1 ? '1 ora' : `${diffHours} ore`;
  const minutesLabel = remainingMinutes === 1 ? '1 minuto' : `${remainingMinutes} minuti`;
  return `tra ${hoursLabel} e ${minutesLabel}`;
};

const GettonciniWalletItem = () => {
  const { isSignedIn } = useUser();
  const { balance, isLoading, temporaryLots } = useGettoncini();

  const firstExpiringLot = useMemo(() => {
    const activeLots = Array.isArray(temporaryLots) ? temporaryLots : [];
    return [...activeLots]
      .filter((lot) => lot && typeof lot.remaining_amount === 'number' && lot.remaining_amount > 0 && lot.expires_at)
      .sort((left, right) => new Date(left.expires_at).getTime() - new Date(right.expires_at).getTime())[0] || null;
  }, [temporaryLots]);

  const temporaryLotSummary = useMemo(() => {
    if (!firstExpiringLot) {
      return null;
    }
    const countdown = formatExpirationCountdown(firstExpiringLot.expires_at, Date.now());
    if (!countdown) {
      return null;
    }
    const amount = firstExpiringLot.remaining_amount.toLocaleString('it-IT');
    const label = firstExpiringLot.remaining_amount === 1 ? 'temporaneo' : 'temporanei';
    return `${amount} ${label} in scadenza ${countdown}`;
  }, [firstExpiringLot]);

  const numericBalance = typeof balance === 'number' ? balance : 0;
  const displayBalance = isLoading && isSignedIn ? '...' : numericBalance.toLocaleString('it-IT');
  const description = temporaryLotSummary || 'Usa i tuoi gettoncini per ottenere aiutini e risolvere i giochini';

  return (
    <Link to="/gettoncini" className={styles.accountMenuItem}>
      <div className={styles.menuItemIcon}>
        <GettonciniIcon size={20} />
      </div>
      <div className={styles.menuItemContent}>
        <span className={styles.menuItemLabel}>Gettoncini</span>
        <span className={styles.menuItemDescription}>{description}</span>
      </div>
      <span className={styles.walletBalance}>{displayBalance}</span>
    </Link>
  );
};

export default GettonciniWalletItem;
